////
/// ============================================================================
/// COMPONENT / Sidebar
/// ============================================================================
///
/// @group components
////

export default () => {

    let nav = document.querySelector('.js-sidebar-nav');

    if (!nav) {
        return;
    }

    let menus = nav.querySelectorAll('.sidebar-nav__menu > li');

    menus.forEach(function (menu) {
        // normalize css class
        if (menu.classList.contains('current-menu-parent')) {
            menu.classList.add('is-open');
        }

        // toggle menu
        menu.addEventListener('click', function (event) {
            if (!event.target.closest('.sidebar-nav__menu > li > a')) {
                return;
            }

            menus.forEach(function (el) {
                if (el !== menu) {
                    el.classList.remove('is-open');
                }
            });

            menu.classList.toggle('is-open');
        });
    });

};
